import React, { useContext } from "react";
import TransaccionalContext from "../context/TransaccionalContext";

const ContainerCompanyLogo = () => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  return (
    <header className="movimientoCliente-menu-header">
      {/* Imagen de la cabecera */}
      {Number(informacionTransaccional?.idGrupo) === 1 ? (
        <img
          style={{ width: "auto", height: "10vh" }}
          src="/images/logo/logo-corpfav.png"
          alt="logo-copfav"
          loading="lazy"
        />
      ) : Number(informacionTransaccional?.idGrupo) === 2 ? (
        <img
          style={{ width: "auto", height: "11.5vh" }}
          src="/images/logo/logo-corpfav.png"
          alt="logo-copfav"
          loading="lazy"
        />
      ) : Number(informacionTransaccional?.idGrupo) === 3 ? (
        <img
          style={{ width: "auto", height: "11.5vh" }}
          src="/images/logo/logo-tvtas.png"
          alt="logo-copfav"
          loading="lazy"
        />
      ) : Number(informacionTransaccional?.idGrupo) === 4 ? (
        <img
          style={{ width: "auto", height: "11.5vh" }}
          src="/images/logo/logo-corpfav.png"
          alt="logo-copfav"
          loading="lazy"
        />
      ) : (
        <img
          style={{ width: "auto", height: "11.5vh" }}
          src="/images/logo/logo-corpfav.png"
          alt="logo-copfav"
          loading="lazy"
        />
      )}
    </header>
  );
};

export default ContainerCompanyLogo;
